module.exports = __webpack_public_path__ + "img/consultants-active.8ba889e3.svg";